import debounce from '../utils/debounce';
import { breakpoints } from '../utils/breakpoints';

export let closeMenu = () => {};

const handleMobileNav = () => {
  const selectors = {
    menu: '.js-menu-mobile',
    hamburger: '.js-menu-hamburger',
  };

  const state = {
    active: 'is-active',
  };

  const menu = document.querySelector(selectors.menu);
  const hamburger = document.querySelector(selectors.hamburger);

  if (!menu || !hamburger) return;

  closeMenu = () => {
    menu.classList.remove(state.active);
    hamburger.classList.remove(state.active);
    document.body.classList.remove('ui-overflow');
  };

  hamburger.addEventListener('click', () => {
    menu.classList.toggle(state.active);
    hamburger.classList.toggle(state.active);
    document.body.classList.toggle('ui-overflow');
  });

  window.addEventListener(
    'resize',
    debounce(() => {
      if (window.innerWidth < breakpoints.tablet) return;

      closeMenu();
    }, 300)
  );
};

export default handleMobileNav;
